import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 600,
      "data-sign": "fba_return_account_auth_modal",
      "title": _vm.formData.id ? _vm.t('重新授权') : _vm.t('新增Amazon账号')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "14px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.t('为了避免接口异常，请确保您的亚马逊店铺状态保持正常')))]), _c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "data-sign": "fba_return_account_auth_form",
      "label-col": _vm.labelCol,
      "rules": _vm.formDataRule,
      "model": _vm.formData,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4E9A\u9A6C\u900A\u5E97\u94FA\u7AD9\u70B9"),
      "prop": "site",
      "label": _vm.t('亚马逊店铺站点')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择店铺站点'),
      "disabled": _vm.isAuthAction
    },
    model: {
      value: _vm.formData.site,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "site", $$v);
      },
      expression: "formData.site"
    }
  }, _vm._l(_vm.smazonSiteEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4E9A\u9A6C\u900A\u5E97\u94FA\u8D26\u53F7"),
      "prop": "account_name",
      "label": _vm.t('亚马逊店铺账号')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "disabled": _vm.isAuthAction,
      "show-search": "",
      "placeholder": _vm.t('请填写亚马逊登录邮箱'),
      "maxLength": 50
    },
    model: {
      value: _vm.formData.account_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "account_name", $$v);
      },
      expression: "formData.account_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u663E\u793A\u540D\u79F0"),
      "prop": "platform_user_name",
      "label": _vm.t('显示名称')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "disabled": _vm.isAuthAction,
      "placeholder": _vm.t('仅用于方便您识别'),
      "maxLength": 50
    },
    model: {
      value: _vm.formData.platform_user_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "platform_user_name", $$v);
      },
      expression: "formData.platform_user_name"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('a-button', {
    attrs: {
      "data-sign": "fba_return_account_auth_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "loading": _vm.loading,
      "data-sign": "fba_return_account_auth_action",
      "type": "primary",
      "fbu-analyse-name": $t("\u6388\u6743")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('授权')))])], 1)])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };